import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getCountryNameByCountryCode, getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

export default function customizedReportsTableColumns(config) {
    let result = {};
    let tableData = [];

    const { customizedReportsList = [] } = config.data;

    customizedReportsList.map((customizedReports) => {
        let row = [];
        const rowId = customizedReports.orderId;
        config.columns.forEach(column => {

            let columnValue = "";
            let customEventHandler = null;
            const columnDataType = column.data.displayInBodyAs;
            let isDisabled = false;

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "orderId") {
                    columnValue = customizedReports.orderId || "";
                    displayAsIs = true;
                }
                else if (column.id === "orderType") {
                    columnValue = customizedReports.orderType?(customizedReports.orderType==="1"?"Collection":"Self shipment"):"";
                    displayAsIs = true;
                }
                else if (column.id === "collectionCity") {
                    columnValue = customizedReports.collectionCity || "";
                    displayAsIs = true;
                }
                else if (column.id === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(customizedReports.createdDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "country") {
                    columnValue = getCountryNameByCountryCode(customizedReports.countryCode) || "";
                    displayAsIs = true;
                }
                else if (column.id === "legalEntityName") {
                    columnValue = customizedReports.legalEntity || "";
                    displayAsIs = true;
                }
                else if (column.id === "company") {
                    columnValue = customizedReports.company || "";
                    displayAsIs = true;
                    isDisabled= true;
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: customEventHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}